import axios, { uploadFile } from "./axios";

/**
 * @function buildFormData
 * @description Constructs a FormData object from a tour data object, handling files and JSON arrays.
 * @param {Object} data - The tour data object.
 * @param {boolean} isUpdate - True if this is an update operation, to include _method=PUT.
 * @returns {FormData} The constructed FormData object.
 */
const buildFormData = (data, isUpdate = false) => {
  const formData = new FormData();

  if (isUpdate) {
    formData.append("_method", "PUT");
  }

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];

      if (key === "thumbnail" && value instanceof File) {
        formData.append(key, value);
      } else if (key === "images" && Array.isArray(value)) {
        value.forEach((file, index) => {
          if (file instanceof File) {
            formData.append(`images[${index}]`, file);
          }
        });
      } else if (key === "delete_images" && Array.isArray(value)) {
        // ✅ Envoyer chaque image à supprimer séparément pour que Laravel puisse parser en array
        value.forEach((imagePath, index) => {
          formData.append(`delete_images[${index}]`, imagePath);
        });
      } else if (key === "itinerary" && value !== null && value !== undefined) {
        // ✅ Envoyer itinerary comme JSON string (value est déjà un array)
        formData.append(key, JSON.stringify(value));
      } else if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    }
  }
  return formData;
};

// Build version: 2026-01-01-v2-json-only
const tourApi = {
  listTours: () => axios.get("/tours"),
  getTourDetails: (id) => axios.get(`/tours/${id}`),
  createTour: (tourData) => {
    const formData = buildFormData(tourData);
    return uploadFile("/tours", formData);
  },
  updateTour: (id, tourData) =>
    uploadFile(`/tours/${id}`, buildFormData(tourData, false)),
  deleteTour: (id) => axios.delete(`/tours/${id}`),
};

export default tourApi;
